export enum ShippingType {
    standard = 'standard_shipping',
    thirdParty = 'third_party_shipping',
}
